import { Routes } from '@angular/router';
import { LevelStatusComponent } from './level-status/level-status.component';

export const PopupsRoutes: Routes = [
    { path: 'level-status', component: LevelStatusComponent, outlet: 'levelpopup' }
];